<template >
  <html >
    <head >
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link rel="icon" type="image/png" href="favicon.png" />
      <title>Restó APP</title>
    </head>
    <body class="home-page">
      <Header :isRestoCompleto="!firstTime" ></Header>
      <div class="col-lg-8 mx-auto p-3 py-md-5">
        <main >
          <h3>Bienvenido a Resto UP</h3>
        </main>
        <Footer />
      </div>
    </body>
  </html>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
export default {
  name: "Inicio",
  components: { Header, Footer },
  data: function () {
    return {
      firstTime: false,
      error: false,
      error_msg: "",
      success: false,
      success_msg: "",
    };
  },
  beforeMount() {
  },
  computed: {
  },
  methods: {

    goToPageFirstTime(page) {
      this.$router.push({ name: page, params: { firstTime: true } });
    },
    goToPage(page, $event) {
      this.$router.push({ name: page});
      $event?.preventDefault();
    },
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #f5f8fa;
  --second-color: #f5f8fa;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}
body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
#tablas {
  display: flex;
}
.btn-primary{
  margin: 15px;
}
</style>
